import styled from 'styled-components';
import { media } from '@bitcoin-portal/bitcoincom-pkg-theme';
import Section from '@bitcoin-portal/bitcoincom-pkg-components/dist/Section';

export const StyledSection = styled(Section)`
  order: 2;
  background: #ffffff !important;
  padding: 20px 24px 40px 24px !important;
  margin: 0px !important;
  padding-bottom: 0px !important;

  ${media.md`
    padding: 44px 44px 60px 44px !important;
    padding-bottom: 0px !important;
  `}

  ${media.lg`
    padding: 80px 80px 0px 80px !important;
    gap: 60px;
  `}
`;

export const StyledContentBlock = styled.div`
  max-width: 1440px;
  padding: 0px !important;
  margin: auto;
`;

export const Topwrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
  ${media.md`
    gap: 16px;
  `}
  ${media.lg`
    gap: 24px;
  `}
`;

export const Title = styled.h1`
  color: var(--Shades-900, #1c1c1c);
  text-align: center;
  font-family: 'Elza Condensed', sans-serif;
  font-size: 40px;
  font-style: normal;
  font-weight: 900;
  line-height: 85%;
  letter-spacing: -0.8px;
  text-transform: uppercase;
  margin: 0px;
  ${media.md`
    font-size: 70px;
    letter-spacing: -1.4px;
  `}
  ${media.lg`
    width: 768px;
    font-size: 90px;
    letter-spacing: -1.8px;
  `}
  ${media.xl`
    width: 768px;
    font-size: 110px;
    letter-spacing: -2.2px;
  `}
`;

export const Subtitle = styled.p`
  color: var(--Shades-600, #818085);
  font-family: 'Satoshi Variable Medium', sans-serif;
  font-size: 18px;
  font-style: normal;
  font-weight: 500;
  line-height: 150%;
  margin: 0px;
  text-align: center;
  ${media.md`
    font-size: 22px;
    font-style: normal;
    font-weight: 500;
    line-height: 123%;
  `}
  ${media.lg`
    font-size: 24px;
    font-style: normal;
    font-weight: 500;
    line-height: 123%;
  `}
  ${media.xl`
    font-size: 28px;
    font-style: normal;
    font-weight: 500;
    line-height: 123%;
  `}
`;

export const Greywrapper = styled.div`
  display: none;
  ${media.lg`

    gap: 60px;
    display: flex;
    width: 696px;
    padding: 26px 16px 26px 24px;
    justify-content: space-between;
    align-items: center;
    border-radius: 10px;
    background: var(--Blue-50, #e8edfa);
    display:flex;
  `}
`;

export const ButtonText = styled.p`
  color: var(--Grey-Scale-900, #1c1c1c);
  text-align: center;
  font-family: 'Satoshi Variable Medium', sans-serif;
  font-size: 18px;
  font-style: normal;
  font-weight: 500;
  line-height: 150%;
  margin: 0px;
  ${media.md`
    font-size: 20px;
    line-height: 130%;
  `}
`;

export const BlueText = styled.p`
  color: var(--Blue-500, #4169e1);
  /* Title/XS 34 */
  font-family: 'Elza Condensed', sans-serif;
  font-size: 34px;
  font-style: normal;
  font-weight: 900;
  line-height: 89%; /* 30.26px */
  letter-spacing: -0.68px;
  text-transform: uppercase;
  margin: 0px;
`;

export const Button = styled.button`
  display: flex;
  height: 48px;
  width: 233px;
  justify-content: center;
  align-items: center;
  gap: 8px;
  border-radius: 116.162px;
  background: var(--orange-500, #ff9500);
  border: none;
  position: relative;
  overflow: hidden;
  z-index: 1;
  transition: background 0.3s ease, color 0.3s ease;

  &:hover {
    background: #ff7c18;
  }

  .ripple {
    position: absolute;
    border-radius: 50%;
    transform: scale(0);
    animation: ripple-animation 1.5s ease-out;
    background-color: rgba(204, 85, 0, 0.6);
    pointer-events: none;
    z-index: 0;
  }

  @keyframes ripple-animation {
    to {
      transform: scale(4);
      opacity: 0;
    }
  }
  ${media.md`
    display: flex;
    height: 56px;
    width: 256px;
    justify-content: center;
    align-items: center;
    gap: 9px;
  `}
  ${media.lg`
    display: none;
    
  `}
`;

export const QrImage = styled.img`
  width: 66px;
  height: 66px;
  display: flex;
`;

export const Blackcircle = styled.img`
  width: 28px;
  height: 28px;
`;

export const Appwrapper = styled.div`
  display: none;
  ${media.lg`
    display: flex;
    align-items: center;
    gap: 12px;
  `}
`;

export const Apptext = styled.p`
  color: var(--Shades-900, #1c1c1c);
  font-family: 'Satoshi Variable Medium', sans-serif;
  font-size: 20px;
  font-style: normal;
  font-weight: 500;
  line-height: 130%;
`;

export const Iconwrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
`;

export const Icon = styled.img`
  width: 32px;
  height: 32px;
  aspect-ratio: 1/1;
`;

export const HeroImage = styled.img`
  width: 220px;

  display: flex;
  justify-content: center;
  align-items: center;

  ${media.md`
    width: 378px;

    display: flex;
    justify-content: center;
    align-items: center;
  `}
`;

export const HeroImageWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 40px;
  ${media.lg`
    margin-top: 60px;
  `}
`;
